import URI from 'jsuri';

import API from 'js/lib/api';

const subscriptionsV1Api = API('/api/subscriptions.v1', {
  type: 'rest',
});

export default subscriptionsV1Api;

export const applyDiscountToSubscription = ({
  subscriptionId,
  promoCodeId,
}: {
  subscriptionId: string;
  promoCodeId: string;
}) => {
  const uri = new URI()
    .addQueryParam('action', 'applyDiscountToSubscription')
    .addQueryParam('promoCodeId', promoCodeId)
    .addQueryParam('id', subscriptionId);

  return subscriptionsV1Api.post(uri.toString());
};
